<template>
    <div class="modal" ref="modal" role="dialog">
        <div class="modal-dialog" :class="sizeClass">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title accresa-modal-title" v-if="title">{{title}}</h4>
                    <slot name="header"></slot>
                    <button type="button" class="close btn-close" @click.prevent="close">
                        <span aria-hidden="true" class="accresa-close-button">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <slot></slot>
                    </div>
                </div>
                <div class="modal-footer" v-if="hasButtons">
                    <div class="button-box">
                        <slot name="buttons"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "bootstrap/js/modal.js";

    export default {
        name: "AcModal",
        props: {title: {type: [String], required: true}, sizeClass: {type: [String], required: false, default: 'modal-lg'}},
        computed: {
            hasButtons() {
                return Boolean(this.$slots.buttons)
            }
        },
        mounted() {
            let self = this;
            $(this.$refs.modal).off('hidden.bs.modal').on('hidden.bs.modal', function () {
                self.$emit('ac-modal-closed', true);
                //console.log("Modal has been closed");
            })
        },
        methods: {
            open() {
                $(this.$refs.modal).modal('show');
            },
            close() {
                $(this.$refs.modal).modal('hide');
                //this.$emit('ac-modal-closed', true);
            }
        }
    }
</script>

<style scoped>
    .accresa-modal-title {
        display: inline;
    }
</style>